import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/addonservices";

// GET
export async function getAddOnService(addOnServicePublicId, apiAccessToken) {
  try {
    console.log("TRYING TO FETCH ADD-ON-SERVICE WITH PUBLIC ID:", addOnServicePublicId); // Debugging
    const response = await axios.get(`${baseUrl}/AddOnService/get-add-on-service/${addOnServicePublicId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    console.log("Receiving request data:", response.data); // Debugging
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Failed to fetch add on service by publicId");
  }
}

export async function getAddOnServicesByAgreement(agreementPublicId, apiAccessToken) {
  try {    
    const response = await axios.get(`${baseUrl}/AddOnService/get-add-on-services-by-agreement/${agreementPublicId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });

    console.log("Fetched add-on-service from API:", response.data);

    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Failed to fetch add-on-service by agreement");
  }
}

// PUT
export async function updateBillingGroupOnAddOnService(
  billingGroupPublicId,
  addOnServicePublicId,
  apiAccessToken
) {
  try {
    const requestData = {
      billingGroupPublicId,
      addOnServicePublicId,
      updatedDateTimeUTC: new Date().toISOString(),
    };
    
    const response = await axios.put(
      `${baseUrl}/AddOnService/update-billing-group-on-add-on-service`,
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API Error Response:", error.response?.data);
    throw new Error(error.response?.data?.message || "Failed to update billing group on add on service"
    );
  }
}

export async function updateAddOnService(addOnServiceData, apiAccessToken) {
  try {
    console.log("Sending update request data:", addOnServiceData); // Debugging

    const response = await axios.put(`${baseUrl}/AddOnService/update-add-on-service`, addOnServiceData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Failed to update add on service");
  }
}

// POST
export async function createAddOnService(addOnServiceData, apiAccessToken) {
  try {
    console.log("Sending create request data:", addOnServiceData); // Debugging

    const response = await axios.post(`${baseUrl}/AddOnService/create-add-on-service`, addOnServiceData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    console.log("Sending request data:", addOnServiceData); // Debugging
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Failed to create add-on-service");
  }
}


// DELETE

export async function deleteAddOnService(addOnServicePublicId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/AddOnService/delete-add-on-service/${addOnServicePublicId}`, {
      headers: {
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Failed to delete add on service");
  }
}